import React from 'react'
import { motion } from "framer-motion"
import styles from './CardImage.module.scss'

const cardAnimation = {
    hidden: {
        y: 70,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .7}
    } 
}


const CardImage = ({item}) => {

    return (
        <motion.li 
            className={styles.item}  
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.05, once: true}}
            variants={cardAnimation} 
            >
            <img className={styles.image} src={item.image} alt={item.title}/>
        </motion.li>
    )
}

export default CardImage